module.exports = "images/orange.b2e72ac94e878a3a868c3d1e7fa58b36.png";